import { TableConfig } from '@shared/interfaces/table/table-config';

export const odataTableConfig: Partial<TableConfig<any>> = {
  reorder: true,
  saveChanges: true,
  exportable: true,
  copyable: true,
  floatingHeader: true,
  resize: true,
  oData: true,
  pageSize: 25,
  pageSizeSelection: true,
}
